import { defineComponent as n, computed as i, openBlock as l, createBlock as s, resolveDynamicComponent as c, withCtx as m, renderSlot as p } from "vue";
const f = /* @__PURE__ */ n({
  __name: "AccessibleComponent",
  props: {
    is: {},
    omitRoleFor: { type: [Function, Array] },
    role: {}
  },
  setup(t) {
    const o = t, r = i(() => {
      if (!o.omitRoleFor)
        return o.role;
      if (!(typeof o.omitRoleFor == "function" ? o.omitRoleFor(o.is) : o.omitRoleFor.includes(o.is)))
        return o.role;
    });
    return (e, u) => (l(), s(c(e.is), { role: r.value }, {
      default: m(() => [
        p(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["role"]));
  }
});
export {
  f as _
};
